import { createSlice } from "@reduxjs/toolkit";

import { ReduxReducer } from "../../../../interface";
import { Reports } from "../../interface";

import { State } from "./interface";

const initialState: State = {
	reportData: [],
};

const setReportsData: ReduxReducer<State, State> = (state, action) => {
	state.reportData = action.payload.reportData;
};

const reportSalaryReportsUsersActivityData = createSlice({
	name: Reports.ConstantReportSlice.SALARY_REPORTS_USERS_ACTIVITY,
	initialState,
	reducers: {
		setReportsData,
	},
});

export const reportSalaryReportsUsersActivityDataAction =
	reportSalaryReportsUsersActivityData.actions;
export const reportSalaryReportsUsersActivityDataReducer =
	reportSalaryReportsUsersActivityData.reducer;
export type reportSalaryReportsUsersActivityDataState = State;

export default reportSalaryReportsUsersActivityData;
